<template>
<div class="p-6">
  <p>Redirecting…</p>
</div>
</template>

<script>
import StripeServices from '@/services/StripeServices'
const stripeService = new StripeServices()

export default {
  async mounted() {
    const response = await stripeService.generateAccountLink()
    const url = response.data

    window.location = url
  }
}
</script>

<style>

</style>